import styled from 'styled-components'
import { Radio, Space } from 'antd'
import Flex from 'components/Flex'

export const Container = styled(Flex)`
  height: 100vh;
  width: 100vw;
  background-color: #fafafb;
  gap: 40px;
`

export const Wrapper = styled.div`
  width: 48%;
  padding-top: 80px;
`

export const Content = styled(Flex)`
  height: auto;
  width: 100%;
  background-color: white;
  border: 1px solid #e6e7ea;
  box-shadow: 0px 6px 10px rgba(86, 94, 106, 0.1);
  padding: 60px 101px;
  gap: 20px;
  border-radius: 10px;
  margin-bottom: 40px;
`

export const RadioLocal = styled(Radio)`
  font-family: 'Plus Jakarta Sans', sans-serif;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  width: 100%;
  padding: 15px;

  font-weight: 600;
  color: #4d566e;
`
export const RadioLocalGroup = styled(Radio.Group)`
  width: 100%;
`

export const LocalSpace = styled(Space)`
  width: 100%;
`
export const FlexWrap = styled(Flex)`
  width: 100%;
  height: auto;
`

export const LogoSmallText = styled.div`
  font-weight: 500;
  font-size: 0.7857142857142857em;
  line-height: 14px;
  color: #4d566e;
  opacity: 0.3;
`

export const LogoBigText = styled.div`
  font-weight: 700;
  font-size: 1.1428571428571428em;
  line-height: 24px;
  color: #4d566e;
`

export const Logo = styled(Flex)`
  gap: 5px;
  margin-top: 50px;
`
